import React from 'react'
import { Banner } from './Banner'
import { Footer } from './Footer'
import { Leasing } from './Leasing'
import { Navbar } from './ui/Navbar'
import { Viviendanovis } from './Viviendanovis'
import { Viviendavis } from './Viviendavis'

export const Home = () => {
    return (
        <>
            <Navbar/>
            <Banner />
            <Leasing/>
            <Viviendavis/>
            <Viviendanovis/>
            <Footer/>
        </>
    )
}
